/**
 * /eric/tasks/$taskId — Working View (T-052 + T-054).
 *
 * Route config only. Component lives in eric.tasks.$taskId.lazy.tsx
 * (code-split). No loader, beforeLoad, or validateSearch.
 */

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eric/tasks/$taskId')({});
